module.exports = __webpack_public_path__ + "img/shopping-mall-2.88ca30bd.jpg";